import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./OurTeam.scss";
import { ReactSVG } from "react-svg";

const settings = {
  arrows: true,
  infinite: true,
  dots: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },

    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        className: "center",
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function OurTeam() {
  const [myTeam, setMyTeam] = useState([
    {
      image: "/images/choose-7.jpg",
      doctorName: "John Doe Master",
      specailization: "Senior Orthopedic Surgeon",
    },
    {
      image: "/images/choose-3.jpg",
      doctorName: "John Doe Master",
      specailization: "Heart Specialist",
    },
    {
      image: "/images/choose-6.jpg",
      doctorName: "John Doe Master",
      specailization: "Kids Specialist",
    },
    {
      image: "/images/choose-7.jpg",
      doctorName: "John Doe Master",
      specailization: "Senior Orthopedic Surgeon",
    },
    {
      image: "/images/choose-3.jpg",
      doctorName: "John Doe Master",
      specailization: "CDE Specialist",
    },
    {
      image: "/images/choose-6.jpg",
      doctorName: "John Doe Master",
      specailization: "EFG Specialist",
    },
  ]);

  return (
    <div className="our_team" id="our-team" style={{}}>
      <div className="our_team_heading">
        <h2 className="heading-services">FOUNDER</h2>
        <div className="about_line"></div>
        {/* <p>
          Our leader set our global direction,goals and strategies,and support
          nearly 500 team members working in more then 20 countries around the
          world.
        </p> */}
      </div>
      {/* <div className="slider-wraperr">
        <Slider {...settings} className="min_card">
          {myTeam?.map((el) => {
            return (
              <div>
                <div className="members">
                  <div className="our_team_member">
                    <div className="orange_tag"></div>
                    <div className="team_member">
                      <div className="our-team-member">
                        <img src={el.image}></img>
                      </div>
                      <div className="social">
                        <div className="item">
                          <ReactSVG src="/icons/tools/twitter.svg" />
                        </div>
                        <div className="item">
                          <ReactSVG src="/icons/tools/linkedin.svg" />
                        </div>
                        <div className="item">
                          <ReactSVG src="/icons/tools/facebook.svg" />
                        </div>
                      </div>
                    </div>
                    <div className="team-person-desription">
                      <h3 className="ortho_heading1_lady">{el.doctorName}</h3>
                      <p className="ortho_heading3">{el.specailization}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div> */}

      <div>
        <div className="members">
          <div className="our_team_member">
            <div className="orange_tag"></div>
            <div className="team_member">
              <div className="our-team-member">
                <img src={"/images/lawyer.jpeg"}></img>
              </div>
              <div className="social">
                <div className="item">
                  <ReactSVG src="/icons/tools/twitter.svg" />
                </div>
                <div className="item">
                  <ReactSVG src="/icons/tools/linkedin.svg" />
                </div>
                <div className="item">
                  <ReactSVG src="/icons/tools/facebook.svg" />
                </div>
              </div>
            </div>
            <div className="team-person-desription">
              <h3 className="ortho_heading1_lady">Tracye J. Lawyer</h3>
              <p className="ortho_heading3">MD, PhD, FAAOS, ABOS</p>
            </div>
          </div>
          <div className="member_description">
            <p>
              Tracye J. Lawyer, MD, PhD, FAAOS, ABOS is board certified and
              fellowship trained in orthopedic sports medicine and serves as the
              medical director for St. Luke’s cartilage preservation and
              restoration program. She specializes in arthroscopic and open
              surgery of the shoulder, elbow, and knee. <br />
              <br />
              In addition to her medical degree, she also earned a PhD focusing
              on cartilage regeneration. Her special interests include pediatric
              and adult cartilage repair and restoration of the knee, shoulder
              and elbow, ACL reconstruction, meniscus repairs, meniscal
              allograft transplantation, multi-ligament knee reconstruction,
              patellar instability, total and reverse shoulder arthroplasty,
              rotator cuff repair, biceps tendon repairs, shoulder instability
              surgery and ligament reconstruction of the elbow.
              <br />
              <br /> Dr. received her medical degree from The Ohio State
              University and her orthopedic residency training at the University
              of Mississippi Medical Center. She completed a sports medicine
              fellowship at the University of Pittsburgh where she worked with
              leaders and innovators in sports medicine, Dr. Freddie Fu and Dr.
              James Bradley. During her fellowship, she worked with the
              Pittsburgh Steelers and Pittsburgh Penguins. She has authored
              multiple peer reviewed research articles and has presented her
              work at national meetings. Dr. Lawyer is the team physician for
              the Rocky Mountain High School Grizzlies and Boise Hawks. <br />
              <br /> Dr. Lawyer earned her bachelor’s degree at Stanford
              University, where she was a two-sport athlete. She earned PAC-10
              Player of the Year in soccer and was an NCAA track champion in the
              heptathlon. After college, she competed in the U.S. Olympic Trials
              in track and field, gaining valuable experience among the best
              athletes in the world. She later received the honor of induction
              into the Stanford Hall of Fame.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurTeam;
